import React from "react";
import "./css/HeaderBottom.css";
import { HeaderBottomList } from "./constants/index";

const HeaderBottom = () => {
  return (
    <div className="border-top border-bottom py-2 bg-white mt-2 container-fluid">
    <div className="container-fluid d-flex justify-content-between align-items-center flex-wrap">
  {/* Navigation Links with SAL animation */}
  <div
    className="d-flex flex-wrap gap-4"
    data-sal="fade"
    data-sal-duration="700"
    data-sal-delay="100"
  >
    {HeaderBottomList.map((item) => (
      <a data-sal="slide-up" data-sal-duration="2000" data-sal-delay="600"
        key={item.label}
        href={item.path}
        className="text-dark text-decoration-none fw-semibold"
      >
        {item.label}
      </a>
    ))}
  </div>

  {/* Estimate Button with SAL animation */}
  <a
    href="/contact"
    className="btn quote-btn fw-bold"
    data-sal="zoom-in"
    data-sal-duration="700"
    data-sal-delay="800"
  >
    Get Your Estimate
  </a>
</div>

    </div>
  );
};

export default HeaderBottom;
